import { initializeApp } from 'firebase/app';
import { getAuth, browserLocalPersistence, setPersistence } from 'firebase/auth';
import { firebaseConfigForMode, resolveFirebaseMode } from './firebaseProjects';

// WHICH PROJECT THIS BUILD AUTHENTICATES AGAINST — see firebaseProjects.ts.
// The literal that used to sit here named `salesguru-86316` unconditionally,
// which is why dev accounts and paying customers' users shared one identity
// pool: there was no mechanism to vary it, in a codebase that already varies a
// dozen other values per tenant at build time.
const firebaseMode = resolveFirebaseMode(process.env.REACT_APP_FIREBASE_MODE);
const firebaseConfig = firebaseConfigForMode(firebaseMode);

console.log('[Firebase] Initializing Firebase app with project:', firebaseConfig.projectId);
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

// Set persistence to local (default) to maintain auth state across page refreshes
setPersistence(auth, browserLocalPersistence).then(() => {
  console.log('[Firebase] Auth persistence set to LOCAL');
}).catch((error) => {
  console.error('[Firebase] Error setting auth persistence:', error);
});

// Log current auth state
auth.onAuthStateChanged((user) => {
  console.log('[Firebase] Global auth state changed');
});

console.log('[Firebase] Firebase initialized successfully');

export default app;